/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GuardianDto } from '../../models/guardian-dto';

export interface AdminGuardianControllerChangeMainGuardian$Params {
  childId: string;
  parentId: string;
  centerId: string;
}

export function adminGuardianControllerChangeMainGuardian(http: HttpClient, rootUrl: string, params: AdminGuardianControllerChangeMainGuardian$Params, context?: HttpContext): Observable<StrictHttpResponse<GuardianDto>> {
  const rb = new RequestBuilder(rootUrl, adminGuardianControllerChangeMainGuardian.PATH, 'patch');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('parentId', params.parentId, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuardianDto>;
    })
  );
}

adminGuardianControllerChangeMainGuardian.PATH = '/api/guardian/admin/change';
